import { render, staticRenderFns } from "./AuthSignUp.vue?vue&type=template&id=387f9644&scoped=true&"
import script from "./AuthSignUp.vue?vue&type=script&lang=js&"
export * from "./AuthSignUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387f9644",
  null
  
)

export default component.exports